
//Data imports
import AccessMatrix from "@/router/access-matrix";
//View and component imports
//import PlannedConstruction from "@/views/landingpages/PlannedConstruction.vue";
const AdminPage = () => import("@/views/admin/AdminPage.vue");

const PartnerAccountList = () => import("@/views/admin/accounts/PartnerAccountList.vue");

const AdminPartnerCompanyList = () => import("@/views/admin/partnercompany/AdminPartnerCompanyList.vue");
const NewPartnerCompany = () => import("@/views/admin/partnercompany/NewPartnerCompany.vue");
import Title_PartnerCompany from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_PartnerCompany.vue";
const ViewPartnerCompanyContainer = () => import("@/views/admin/partnercompany/ViewPartnerCompanyContainer.vue");
const ViewPartnerCompanyInfo = () => import("@/views/admin/partnercompany/ViewPartnerCompanyInfo.vue");

const PartnerEmailSetting = () => import("@/views/admin/partnercompany/PartnerEmailSetting.vue");

//Export item
const trunk = {
  meta: {
    licenceEnabled: "PartnerPortal",
    authorize: AccessMatrix.AdminTrunk.module,
    display: { key: "servicesystem.pages.page_titles.partner" },
    icon: "$partner"
  },
  name: "Partner",
  redirect: { name: "PartnerCompanies" },
  path: "/partner",
  component: AdminPage,
  children: [
  /*
    {
      meta: {
        licenceEnabled: "PartnerPortal",
        authorize: AccessMatrix.AdminTrunk.partner_company,
        display: { key: "Partner jobs" },
        icon: "$job",
      },
      name: 'PartnerJobs',
      path: 'jobs',
      component: PartnerAccountList,
      children: [
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            display: { key: "Dispatched" },
            icon: "$job",
          },
          name: 'PartnerPlannedJobs',
          path: 'dispatched',
        },
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            display: { key: "Work started" },
            icon: "$job",
          },
          name: 'PartnerStartedJobs',
          path: 'started',
        },
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            display: { key: "Work finished" },
            icon: "$job",
          },
          name: 'PartnerFinishedJobs',
          path: 'finished',
        },
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            display: { key: "Closed" },
            icon: "$job",
          },
          name: 'PartnerClosedJobs',
          path: 'closed',
         }
       ]
    },
    */
    {
      meta: {
        licenceEnabled: "PartnerPortal",
        authorize: AccessMatrix.AdminTrunk.machines_branch,
        display: { key: "servicesystem.common_objects.partner_company.partner_companies" },
        icon: "$partner_company",
        overrides: {
          header: {
            buttons: ['NewEntityBtn'],
          },
        },
        newEntityBtnTo: { name: 'NewPartnerCompany' },
      },
      path: "companies",
      name: "PartnerCompanies",
      component: AdminPartnerCompanyList,
      children: [
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            display: { key: "servicesystem.common_objects.commonterms.new" },
            icon: "mdi-plus",
            overrides: {
              sidebar: false,
              headercard: false,
            },
          },
          path: "new",
          name: "NewPartnerCompany",
          component: NewPartnerCompany,
        },
        {
          meta: {
            licenceEnabled: "PartnerPortal",
            authorize: AccessMatrix.AdminTrunk.partner_company,
            overrides: {
              sidebar: false,
              headercard: false,
              title: Title_PartnerCompany,
            },
            contextMenu: true,
          },
          path: ":partnerCompanyId",
          name: "ViewPartnerCompany",
          component: ViewPartnerCompanyContainer,
          redirect: { name: "ViewPartnerCompanyInfo" },
          children: [
            {
              meta: {
                licenceEnabled: "PartnerPortal",
                authorize: AccessMatrix.AdminTrunk.departments,
                displayName: "Info",
                icon: "mdi-home"
              },
              path: "info",
              name: "ViewPartnerCompanyInfo",
              component: ViewPartnerCompanyInfo
            },
            {
              meta: {
                licenceEnabled: "PartnerPortal",
                authorize: AccessMatrix.AdminTrunk.departments,
                display: { key: "servicesystem.pages.page_titles.admin_accounts" },
                icon: "$accounts",
                overrides: {
                  header: {
                    buttons: ['NewAccountBtn'],
                  },
                }
              },
              name: 'PartnerCompanyUsers',
              path: 'users/:userId?',
              component: PartnerAccountList,
            },
          ]
        }
      ]
    },

    {
      meta: {
        licenceEnabled: "PartnerPortal",
        authorize: AccessMatrix.AdminTrunk.partner_company,
        display: { key: "servicesystem.pages.page_titles.admin_accounts_partners" },
        icon: "$partner",
        overrides: {
          header: {
            buttons: ['NewAccountBtn'],
          },
        }
      },
      name: 'PartnerUsers',
      path: 'users/:userId?',
      component: PartnerAccountList,
    },
    
    {
      meta: {
        licenceEnabled: "PartnerPortal",
        authorize: AccessMatrix.AdminTrunk.partner_company,
        display: { key: "servicesystem.pages.page_titles.admin_partner_email" },
        icon: "mdi-email-edit",
      },
      name: 'PartnerEmail',
      path: 'email',
      component: PartnerEmailSetting,
    },
  ]
};
export default trunk;
